export default class PdfViewerToolbarButtonComponent {
    constructor(config) {
        this.config = config;
        this.prefix = 'sp-pdf-viewer';
        this.isActiveClassName = `${this.prefix}-toolbar-button--is-active`;
        this._isDisabled = false;
        this._isActive = false;
        this.onClick = () => {
            this.config.action();
        };
        this.render = () => {
            const { hostElement, icon, className, label, testLabel, onFocus, onBlur } = this.config;
            this.element = document.createElement('button');
            this.element.classList.add('sp-pdf-viewer-toolbar-button');
            this.element.innerHTML = `<span class="${this.prefix}-toolbar-button_wrapper"><span class="icon">${icon}</span></span><span class="${this.prefix}-toolbar-button_focus-overlay"></span>`;
            if (className) {
                this.element.classList.add(className);
            }
            if (testLabel) {
                this.element.setAttribute('data-test-label', testLabel);
            }
            if (label) {
                this.element.setAttribute('title', label);
            }
            this.element.addEventListener('click', this.onClick);
            if (onFocus) {
                this.element.addEventListener('focus', onFocus);
            }
            if (onBlur) {
                this.element.addEventListener('blur', onBlur);
            }
            hostElement.appendChild(this.element);
        };
        this.destroy = () => {
            const { hostElement, onFocus, onBlur } = this.config;
            this.element.removeEventListener('click', this.onClick);
            hostElement.removeChild(this.element);
            if (onFocus) {
                this.element.removeEventListener('focus', onFocus);
            }
            if (onBlur) {
                this.element.removeEventListener('blur', onBlur);
            }
            this.element = null;
        };
    }
    set isDisabled(value) {
        this._isDisabled = value;
        this.element.disabled = this._isDisabled;
    }
    set isActive(value) {
        this._isActive = value;
        this._isActive ? this.element.classList.add(this.isActiveClassName) : this.element.classList.remove(this.isActiveClassName);
    }
}
//# sourceMappingURL=pdf-viewer-toolbar-button.component.js.map